import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AssignmentTextAdPage } from './assignment-text-ad.page';

const routes: Routes = [
  {
    path: '',
    component: AssignmentTextAdPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AssignmentTextAdPageRoutingModule {}
